import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
  initialSubscriptionIdState,
  ISubscriptionIdState,
} from "@src/Model/Model"

export const subscriptionIdSlice = createSlice({
  name: "counter",
  initialState: initialSubscriptionIdState,
  reducers: {
    updateSubscriptionId: (
      _state,
      action: PayloadAction<ISubscriptionIdState>,
    ) => action.payload,
  },
})

export const actions = subscriptionIdSlice.actions

export default subscriptionIdSlice.reducer
